import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getShippingOrder } from "../../redux/actions/shippingOrderAction";
import ShippingTable from "./ShippingOrderTable";

const ShippingOrder = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("PLACED");
 
    useEffect(() => {
        dispatch(getShippingOrder(setLoading, statusFilter));
    }, [dispatch, statusFilter]);
 
    const allShippingOrder = useSelector((state) => state.shippingOrder.allShippingOrder || []);
 
    const processedShippingOrder = useMemo(() => {
        const normalizedSearch = search.trim().toLowerCase();
        const compactSearch = normalizedSearch.replace(/[\s-]/g, "");

        return allShippingOrder
            // Payment-pending orders are not shippable yet — hide them from the
            // shipping list (backend also filters these once deployed).
            .filter((item) => item?.paymentStatus === "paid" && item?.status !== "PENDING")
            .filter((item) => {
                if (!normalizedSearch) return true;

                const searchableValues = [
                    item?.srNo,
                    item?._id,
                    item?.user?.firstName,
                    item?.user?.lastName,
                    item?.user?.mobile,
                    item?.user?.email,
                    item?.user?.userId,
                    item?.vehicle?.vehicleNumber,
                    item?.shippingAddress?.firstName,
                    item?.shippingAddress?.lastName,
                    item?.shippingAddress?.address,
                    item?.shippingAddress?.city,
                    item?.shippingAddress?.state,
                    item?.shippingAddress?.pinCode,
                    item?.customerName,
                    item?.customerPhone,
                    item?.customerEmail,
                ];

                return searchableValues.some((value) => {
                    const normalizedValue = String(value ?? "").toLowerCase();
                    return (
                        normalizedValue.includes(normalizedSearch) ||
                        normalizedValue.replace(/[\s-]/g, "").includes(compactSearch)
                    );
                });
            })
            .map((item) => ({
                ...item,
                time: item.time ? new Date(item.time) : null,
            }));
    }, [allShippingOrder, search]);
 
    return (
        <ShippingTable
            heading="Shipping Orders"
            allShippingOrder={processedShippingOrder}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            refreshData={() => dispatch(getShippingOrder(undefined, statusFilter))}
        />
    );
};
 
export default ShippingOrder;
 
